import { InferType, object, string } from 'yup';

export enum JobsBoardSearchFormFields {
  City = 'city',
  Area = 'area'
}

export const validationSchema = object({
  [JobsBoardSearchFormFields.City]: string().required('City is required.'),
  [JobsBoardSearchFormFields.Area]: string().nullable()
});

export type JobsBoardSearchFormSchemaType = InferType<typeof validationSchema>;
